<template>
  <div class="main-container">
    <div class="inner-container">
        <div class="filter-input-container">
            <div class="inner-filter-container">
                <select id="filterField" v-model="selectedField">
                    <option disabled selected value="">Filter Options</option>
                    <option v-if="filterByService" value="service">Service</option>
                    <option v-if="filterByReference" value="ref1">Reference</option>
                    <option v-if="filterByCompanyName" value="companyName">Company Name</option>
                    <option v-if="filterByAddress" value="address1">Address</option>
                    <option v-if="filterByCity" value="city">City</option>
                    <option v-if="filterByState" value="state">State</option>
                    <option v-if="filterByZipCode" value="zipCode">ZipCode</option>
                    <option v-if="filterByGeoCode" value="zipCode">GeoCode</option>
                    <option v-if="filterByRouteCode" value="routeCode">RouteCode</option>
                    <option v-if="filterByPlaceCode" value="placeCode">Place Code</option>
                    <option v-if="filterByAccountNo" value="accountNo">Account No.</option>
                    <option v-if="filterByInvoiceID" value="invoiceID">Invoice ID</option>
                    <option v-if="filterByUserName" value="username">Username</option>
                    <option v-if="filterByServiceNetwork" value="serviceNetwork">Service Network</option>
                    <option v-if="filterByContact1" value="contact1">Contact 1</option>
                    <option v-if="filterByShipmentID" value="shipmentID">ShipmentID</option>
                    <option v-if="filterByDateRange" value="dateRange">Date Range</option>
                    <option v-if="filterByTripSheetID" value="tripSheetID">Trip Sheet ID</option>
                    <option v-if="filterByExternalTrackingNumber" value="externalTrackingNumber">External ID</option>
                    <option v-if="filterByManifestStatus" value="manifestStatus">Manifest Status</option>
                </select>
            </div>

            <form style="text-align: left;" @submit.prevent="filterValues()">

            
            <div class="inner-filter-container" v-if="selectedField == 'service'">
                <select style="margin-left: 5px;" id="filterField" v-model="filterValue">
                    <option disabled selected value="">Service Options</option>
                    <option value="standard">Standard Service</option>
                    <option value="priority">Priority Service</option>
                    <option value="economy">Economy Service</option>
                </select>
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'manifestStatus'">
                <select style="margin-left: 5px;" id="filterField" v-model="filterValue">
                    <option disabled selected value=""></option>
                    <option value="Dispatched">Dispatched</option>
                    <option value="Optimized">Optimized</option>
                    <option value="Optimization Failed">Optimization Failed</option>
                    <option value="Optimizing">Optimizing</option>
                </select>
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'externalTrackingNumber'">
                <input placeholder="External ID" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'tripSheetID'">
                <input placeholder="Trip Sheet ID" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'ref1'">
                <input placeholder="Reference" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'companyName'">
                <input placeholder="Company Name" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'address1'">
                <input placeholder="Address" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'city'">
                <input placeholder="City" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'state'">
                <input placeholder="State (ex. NJ)" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'zipCode'">
                <input placeholder="ZipCode (ex. 07103)" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'routeCode'">
                <input placeholder="Route Code" type="text" id="filterValue" :ref="selectedField" v-model="filterValue" @input="filterValue = $event.target.value.toUpperCase()">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'placeCode'">
                <input placeholder="Place Code" type="text" id="filterValue" :ref="selectedField" v-model="filterValue" @input="filterValue = $event.target.value">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'accountNo'">
                <input placeholder="Account No." type="text" id="filterValue" :ref="selectedField" v-model="filterValue" @input="filterValue = $event.target.value.toUpperCase()">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'invoiceID'">
                <input placeholder="Invoice ID" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'username'">
                <input placeholder="Username" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'serviceNetwork'">
                <input placeholder="Service Network" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'contact1'">
                <input placeholder="Contact Name" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'shipmentID'">
                <input placeholder="ShipmentID" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container checkbox-container" v-if="(selectedField == 'accountNo' || selectedField == 'dateRange') && showInvoiceCheckbox">
                <label for="">Open only</label>
                <input placeholder="Invoice Status" type="checkbox" id="filterValue" v-model="invoiceCheckBox">
            </div>

            <div class="inner-filter-container checkbox-container" v-if="showInvoiceCheckboxCustomer">
                <label for="">Open only </label>
                <input placeholder="Invoice Status" type="checkbox" id="filterValue" v-model="invoiceCheckBox">
            </div>

            <div v-if="selectedField == 'dateRange'" class="inner-filter-container checkbox-container">
                <label for="">Start Date</label>
                <input placeholder="Start Date" type="date" id="filterValue" v-model="startDate" :min="minDate">
            </div>

            <div v-if="selectedField == 'dateRange'" class="inner-filter-container checkbox-container">
                <label for="">End Date</label>
                <input placeholder="End Date" type="date" id="filterValue" v-model="endDate" :min="minDate">
            </div>

            <div v-if="showDateRange && (selectedField != 'tripSheetID')  && (selectedField != 'dateRange')" class="inner-filter-container checkbox-container">
                <label for="">Start Date</label>
                <input placeholder="Start Date" type="date" id="filterValue" v-model="startDate" :min="minDate">
            </div>

            <div v-if="showDateRange && (selectedField != 'tripSheetID')  && (selectedField != 'dateRange')" class="inner-filter-container checkbox-container">
                <label for="">End Date</label>
                <input placeholder="End Date" type="date" id="filterValue" v-model="endDate" :min="minDate">
            </div>

            <!-- <div v-if="(selectedField == 'routeCode' && showIsoDateTime)" class="inner-filter-container checkbox-container">
                <input
                id="datetime"
                type="datetime-local"
                v-model="localDateTime"
                @change="updateISOFormat"
                />
            </div> -->

            <div class="inner-filter-container" v-if="selectedField == 'dateRange' && (!showInvoiceCheckboxCustomer) && (!removeAccountNoDateRange)">
                <input placeholder="Account No." type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            </form>
            <button @click="filterValues()"><i class="fa fa-filter"></i> Enter</button>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            selectedField: '',
            filterValue: '',
            invoiceCheckBox: false,
            startDate: '',
            endDate: '',
            minDate: this.calculateMinDate(),
            // localDateTime: "",
            // isoDateTime: ""
        }
    },
    computed:{
        showInvoiceCheckbox(){
            return this.$route.name == 'AdminBillingDashboard'
        },
        showInvoiceCheckboxCustomer(){
            return this.$route.name == 'CustomerBillingDashboard'
        },
        showIsoDateTime(){
            return this.$route.name == 'ManifestDashboard'
        },
        removeAccountNoDateRange(){
            return this.$route.name == 'AccountDashboard' || this.$route.name == 'ShipmentDashboard' || this.$route.name == 'AdminShipmentDashboard' || this.$route.name == 'CustomerAdminShipmentDashboard' || this.$route.name == 'TripSheetDashboard'
        }
    },
    watch:{
        'selectedField': function(){
            console.log("SELECTED FIELD")
            this.filterValue = '';
            this.$nextTick(() => this.$refs[this.selectedField]?.focus())
        },
        // 'setIsoDateTime': function(){
        //     if(this.setIsoDateTime != ""){
        //         const date = new Date(this.setIsoDateTime);
        //         const localDate = new Date(date.getTime());

        //         this.localDateTime = localDate.toISOString().slice(0, 16);
        //         console.log(this.setIsoDateTime)
        //         console.log("SET LOCAL TIME: ", localDate.toISOString().slice(0, 16))
        //     }
        // }
    },
    methods:{
        // async updateISOFormat(){
        //     if (this.localDateTime) {
        //         const date = new Date(this.localDateTime);
        //         this.isoDateTime  = date.toISOString();
        //     }
        // },
        filterValues(){
            this.$emit('filterValues', {filterField: this.selectedField, filterValue: this.filterValue, invoiceCheckBox: this.invoiceCheckBox, startDate: this.startDate, endDate: this.endDate}) //, isoDateTime: this.isoDateTime})
        },
        calculateMinDate() {
            const today = new Date();
            const oneYearAgo = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());
            return oneYearAgo.toISOString().split('T')[0]; // Formats as YYYY-MM-DD
        }
    },
    props:['showDateRange', 'setIsoDateTime', 'filterByTripSheetID', 'filterByManifestStatus', 'filterByExternalTrackingNumber', 'filterByDateRange', 'filterByShipmentID', 'filterByAccountNo', 'filterByService', 'filterByReference', 'filterByCompanyName', 'filterByAddress', 'filterByCity', 'filterByState', 'filterByZipCode', 'filterByGeoCode', 'filterByRouteCode', 'filterByPlaceCode', 'filterByUserName', 'filterByContact1', 'filterByServiceNetwork', 'filterByInvoiceID']
}
</script>

<style scoped>
.main-container {
	width: 100%;
	display: flex;
	justify-content: flex-start;
	margin-bottom: 10px;
	margin-top: 5px
}

.inner-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	width: calc(100% - 20px);
	padding: 5px;
	background-color: #fff;
	box-shadow: rgba(0, 0, 0, .15) 0 5px 10px;
	border-radius: 25px
}

.filter-input-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100%;
	flex-wrap: wrap
}

.filter-input-container button {
	background-color: #33f18a;
	color: #fff;
	border: none;
	border-radius: 999px;
	padding: 5px 15px;
	transition-duration: .5s;
	margin-left: auto
}

.filter-input-container button:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.inner-filter-container {
	margin: 5px
}

.inner-filter-container select {
	background-color: #fff;
	padding: 5px 15px;
	border-radius: 25px;
	cursor: pointer;
	border: 1px solid #e2e2e2;
	box-shadow: rgba(0, 0, 0, .05) 0 5px 15px;
	outline: 0
}

.inner-filter-container select:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

option {
	background-color: #fff;
	padding: 5px 15px;
	font-size: 1.1em
}

.inner-filter-container input {
	border: 1px solid #e2e2e2;
	padding: 5px;
	border-radius: 25px;
	box-shadow: rgba(0, 0, 0, .05) 0 5px 15px;
	outline: 0
}

input[type=checkbox] {
	-webkit-appearance: none;
	appearance: none;
	background-color: #fff;
	margin: 0;
	margin-left: 10px;
	cursor: pointer;
	font: inherit;
	color: #33f18a;
	width: 1.05em;
	height: 1.05em;
	border: .15em solid #33f18a;
	border-radius: .15em;
	display: grid;
	place-content: center;
	transition-duration: .5s
}

input[type=checkbox]:hover {
	background-color: #f3f3f3;
	transition-duration: .5s
}

input[type=checkbox]::before {
	content: "";
	width: .65em;
	height: .65em;
	clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0, 43% 62%);
	transform: scale(0);
	transform-origin: bottom left;
	transition: 120ms transform ease-in-out;
	box-shadow: inset 1em 1em var(--form-control-color);
	background-color: CanvasText
}

input[type=checkbox]:checked::before {
	transform: scale(1)
}

.checkbox-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	font-size: 13px
}

@media only screen and (max-width:380px) {
	.filter-input-container button {
		font-size: 10px
	}

	.inner-filter-container select {
		padding: 5px 5px
	}
}
</style>